import React from "react";
import "./Navbar.css";

function Navbar({ activeView, setActiveView, dataStatus }) {
  const menuItems = [
    { id: "upload", label: "Data Upload", icon: "📁", requiresData: false },
    {
      id: "analysis",
      label: "Analysis Report",
      icon: "📋",
      requiresData: ["sales", "costs"],
    },
    {
      id: "sales",
      label: "Sales Analytics",
      icon: "📊",
      requiresData: ["sales"],
    },
    {
      id: "products",
      label: "Product Performance",
      icon: "🛍️",
      requiresData: ["sales", "costs"],
    },
    {
      id: "profit",
      label: "Profit Analysis",
      icon: "💰",
      requiresData: ["sales", "costs"],
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "📈",
      requiresData: ["sales", "costs"],
    },
    { id: "ai", label: "AI Assistant", icon: "🤖", requiresData: ["sales"] },
  ];

  const isMenuItemEnabled = (item) => {
    if (!item.requiresData || item.requiresData.length === 0) return true;
    return item.requiresData.every((dataType) => dataStatus[dataType]);
  };

  const getDataStatusIcon = (dataType) => {
    return dataStatus[dataType] ? "✅" : "❌";
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <h1>🍽️ Restaurant Analytics</h1>
      </div>

      <div className="navbar-menu">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeView === item.id ? "active" : ""} ${
              !isMenuItemEnabled(item) ? "disabled" : ""
            }`}
            onClick={() => isMenuItemEnabled(item) && setActiveView(item.id)}
            disabled={!isMenuItemEnabled(item)}
            title={
              !isMenuItemEnabled(item)
                ? `Requires: ${item.requiresData?.join(", ")} data`
                : ""
            }
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </div>

      <div className="data-status">
        <div className="status-item">
          <span>{getDataStatusIcon("sales")}</span>
          <span>Sales</span>
        </div>
        <div className="status-item">
          <span>{getDataStatusIcon("costs")}</span>
          <span>Costs</span>
        </div>
        <div className="status-item">
          <span>{getDataStatusIcon("raws")}</span>
          <span>Materials</span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
